import PropTypes from 'prop-types';
import { Box, Divider, Skeleton } from '@mui/material';
import { WEIGHT_SIGNALS } from './healthScoreWeightingConstants';

const HealthScoreWeightingSkeleton = ({ showButton }) => (
	<Box
		data-testid='health-score-weighting-skeleton'
		sx={{
			backgroundColor: 'background.paper',
			border: '0.5px solid',
			borderColor: 'border.light',
			borderRadius: '8px',
			overflow: 'hidden',
		}}
	>
		<Box
			sx={{
				display: 'flex',
				alignItems: 'flex-start',
				justifyContent: 'space-between',
				gap: '16px',
				padding: '10px 12px',
			}}
		>
			<Box sx={{ flex: 1 }}>
				<Skeleton variant='text' width={190} height={20} />
				<Skeleton variant='text' width='60%' height={16} />
			</Box>

			{showButton && <Skeleton variant='rounded' width={100} height={30} />}
		</Box>

		<Divider />

		<Box sx={{ padding: '12px' }}>
			{WEIGHT_SIGNALS.map(({ key }) => (
				<Box
					key={key}
					sx={{
						display: 'flex',
						alignItems: 'flex-start',
						justifyContent: 'space-between',
						gap: '16px',
						backgroundColor: 'background.subtle',
						borderRadius: '7px',
						padding: '10px 12px',
						mb: '8px',
					}}
				>
					<Box sx={{ flex: 1 }}>
						<Skeleton variant='text' width={150} height={18} />
						<Skeleton variant='text' width='75%' height={16} />
					</Box>

					<Skeleton variant='rounded' width={110} height={26} />
				</Box>
			))}

			<Divider />

			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					padding: '10px 12px',
				}}
			>
				<Skeleton variant='text' width={60} height={18} />
				<Skeleton variant='text' width={45} height={18} />
			</Box>
		</Box>
	</Box>
);

HealthScoreWeightingSkeleton.propTypes = {
	showButton: PropTypes.bool.isRequired,
};

export default HealthScoreWeightingSkeleton;
